<template>
  <div>
    <Breadcrumbs main="" :title="$t('lbl_EMPBE_AdApproval')" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div>
        <localization :language="kendoLang">
          <intl :locale="kendoLang">
            <Grid ref="grid" id="SupplierList_grid" :data-items="gridData" :resizable="true" :reorderable="true" :sortable="false"
              :pageable="gridPageable" :groupable="true" :group="group" :sort="sort" :filter="filter" :take="take"
              :skip="skip" :columns="columns" :column-menu="columnMenu" :selectable="true" :selected-field="selectedField"
              @headerselectionchange="onHeaderSelectionChange" @datastatechange="dataStateChange"
              @selectionchange="onSelectionChange" @pagechange="pageChangeHandler" :total="totalRows" :loader="loader">
              <toolbar>
                <div class="p-t-5 p-b-5">
                  <b-dropdown id="dropdown-1" :text="$t('lbl_EMPBE_BatchAction')" style="width: 200px" class="m-r-10"
                    variant="primary">
                    <!-- <b-dropdown-item @click="resetPassword(0)" v-bind:t_label="'EMPBE_Backend_btnBatchResetPassword'">{{
                      $t("lbl_EMPBE_ResetSelectedPassword") }}</b-dropdown-item> -->
                      <!-- <b-dropdown-item>透過電郵發送已選擇供應商帳號密碼</b-dropdown-item> -->
                    <!-- <b-dropdown-divider></b-dropdown-divider> -->
                    <b-dropdown-item @click="sendAccountPassword(0)" v-bind:t_label="'EMPBE_Backend_btnBatchSendAccountPassword'">{{
                      $t("lbl_EMPBE_SendAccountPassword") }}</b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="submitReminder(0)" v-bind:t_label="'EMPBE_Backend_btnBatchSubmitReminder'">{{
                      $t("lbl_EMPBE_SubmitReminder") }}</b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="submitReminderAll()" v-bind:t_label="'EMPBE_Backend_btnBatchSubmitReminderAll'">{{
                      $t("lbl_EMPBE_SubmitReminderAll") }}</b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="researchCompany(0, 'QL')" v-bind:t_label="'EMPBE_Backend_btnBatchQuickLaunchResearch'">
                      {{ "Quick Launch Research" }}
                    </b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="researchCompany(0, 'NC')" v-bind:t_label="'EMPBE_Backend_btnNewCustomerResearch_'">
                      {{ "New Customer Research" }}
                    </b-dropdown-item>
                    
                    <b-dropdown-divider v-show="false"></b-dropdown-divider>
                    <b-dropdown-item v-b-toggle="'stopAccount'" variant="danger" v-show="false"
                      v-bind:t_label="'EMPBE_Backend_btnBatchDisablePassword'">{{ $t("lbl_EMPBE_StopSelectedAccount") }}
                    </b-dropdown-item>
                  </b-dropdown>
                  <!-- <b-form-input type="text" :placeholder="$t('lbl_EMPBE_SearchWord')" v-model="searchWord" @keyup.enter="onFilter"></b-form-input> -->
                   <b-form-input type="text" :placeholder="$t('lbl_EMPBE_SearchWord')" v-model="searchWord" ></b-form-input>
                  <b-button variant="primary" style="width: 150px" @click="onFilter"
                    v-bind:t_label="'EMPBE_Backend_btnSearch'">{{ $t("lbl_EMPBE_Search") }}</b-button>
                </div>
              </toolbar>
              <!-- <template v-slot:CompanyInfoMenuTemplate="{ props }">
                <CompanyInfoFieldColumnMenu :column="props.column" :filterable="props.filterable" :filter="props.filter"
                  :unique-data="true" :items="items" @filterchange="handleFilterChange" @closemenu="() => {
                    props.onClosemenu();
                  }
                    " />
              </template>
              <template v-slot:ProductInfoMenuTemplate="{ props }">
                <ProductInfoFieldColumnMenu :column="props.column" :filterable="props.filterable" :filter="props.filter"
                  :unique-data="true" :items="items" @filterchange="handleFilterChange" @closemenu="() => {
                    props.onClosemenu();
                  }
                    " />
              </template> -->
              <template v-slot:AdInfoMenuTemplate="{ props }">
                <AdInfoFieldColumnMenu :column="props.column" :filterable="false" :filter="filter_adStatus"
                  :unique-data="true"  @filterchange="handleFilterChange" @closemenu="() => { props.onClosemenu();}"  
                  @setAdInfoFilter="setAdInfoFilter"/>
              </template>
              <template v-slot:eBoothTypeColumnMenuTemplate="{ props }">
                <eBoothTypeColumnMenu :column="props.column" :langId="langid" :filterable="false" :filter="filter_ebooth"
                  @filterchange="handleFilterChange"  @closemenu="() => {props.onClosemenu(); }" @setEboothFilter="setEboothFilter" />
              </template>
              <template v-slot:packageTypeColumnMenuTemplate="{ props }">
                <packageTypeColumnMenu :column="props.column" :filterable="false" :filter="props.filter"
                  :sortable="props.sortable" :sort="props.sort" :columns="columns"
                  @sortchange="(e) => props.onSortchange(e)" @filterchange="(e) => props.onFilterchange(e)"
                  @closemenu="(e) => props.onClosemenu(e)" @contentfocus="(e) => props.onContentfocus(e)"
                  :items="packageTypeList" />
              </template>
              <!-- <template v-slot:AccountTypeColumnMenuTemplate="{ props }">
                <AccountTypeColumnMenu :column="props.column" :filterable="props.filterable" :filter="props.filter"
                  :sortable="props.sortable" :sort="props.sort" :columns="columns"
                  @sortchange="(e) => props.onSortchange(e)" @filterchange="(e) => props.onFilterchange(e)"
                  @closemenu="(e) => props.onClosemenu(e)" @contentfocus="(e) => props.onContentfocus(e)"
                  :items="memberGradeList" />
              </template> -->
              <template v-slot:selectedTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  <input type="checkbox" id="checkbox" v-model="rowSelected" role="button" />
                </td>
              </template>
              <template v-slot:companyNameTemplate="{ props }" :filterable="false">
                <td v-if="props.rowType !== 'groupHeader'">
                  <!-- {{ getCompanyNameWithLang(props.dataItem) }}<br /> -->
                  <!-- <i class="fa fa-map-marker m-r-5"></i>{{ props.dataItem.Booth }}<br /> -->
                  <!-- {{ props.dataItem.displayName }}<br /> -->
                  <div class="text-wrap-anywhere" v-if="props.dataItem.companyNameSc != ''">
                    {{props.dataItem.companyNameSc}}
                  </div>
                  <div class="text-wrap-anywhere" v-if="props.dataItem.companyNameEn != ''">
                    {{ props.dataItem.companyNameEn }}
                  </div>

                  <b-dropdown :id="'dropdown-'+props.dataItem.accountId" :text="$t('lbl_EMPBE_Action')" class="p-l-0 btn-lg actionBtn"
                    variant="primary">
                    <!-- <b-dropdown-divider v-show="props.dataItem.haveAd"></b-dropdown-divider> -->
                     <b-dropdown-item @click="openSidebar(props.dataItem)"
                      v-bind:t_label="'EMPBE_Backend__btnAdApproval_' + props.dataItem.accountId">
                      {{ $t('lbl_EMPBE_AdApprovalPortal') }}</b-dropdown-item>

                      <b-dropdown-divider v-show="false"></b-dropdown-divider>
                    <!-- 发送提醒递交电邮-->
                    <b-dropdown-item  @click="submitReminder(props.dataItem.accountId)"
                      v-bind:t_label="'EMPBE_Backend__btnResetPassword_' + props.dataItem.accountId">
                      {{ $t('lbl_EMPBE_SubmitReminder') }}</b-dropdown-item>
                  
                  </b-dropdown>
                </td>
              </template>
              <!--
              <template v-slot:displayNameTemplate="{ props }" >
                <td v-if="props.rowType !== 'groupHeader'">
                  {{ props.dataItem.displayName }}
                </td>
              </template>-->
              <template v-slot:eBoothTypeTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  {{ props.dataItem.eBoothGradeName }}
                </td>
              </template>
              <template v-slot:EMP_CompanyIdTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  {{ props.dataItem.empCompanyId }}
               </td>
              </template>
               <template v-slot:Prospect_IDTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  {{ props.dataItem.prospectId }}
               </td>
              </template>
               <template v-slot:PUB_IOCodeTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  {{ props.dataItem.pubIoNo }}
               </td>
              </template>
               <template v-slot:Contract_NoTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  {{ props.dataItem.contractNo }}
               </td>
              </template>
               <template v-slot:PUB_SalesCodeTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  {{ props.dataItem.salesCodePub }}
               </td>
              </template>
               <template v-slot:CRM_SalesCodeTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  {{ props.dataItem.salesCodeCrm }}
               </td>
              </template>
              
              
              <!-- <template v-slot:accountTypeTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  {{ getMemberGradeWithLang(props.dataItem) }}<br />
                  <span class="badge badge-light" v-if="!props.dataItem.isActive">{{
                    $t("lbl_EMPBE_Disabled")
                  }}</span>
                </td>
              </template> -->
              <template v-slot:packageTypeTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  <div v-for="(item,index) in getPackageNameArray(props.dataItem)"  :key="index" >
                    {{ item }}
                  </div>
                </td>
              </template>
              <template v-slot:membershipExpiryDateTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  {{ DisplayDate(props.dataItem.membershipExpiryDate, "-") }}<br />
                  <span class="badge badge-light" v-if="!props.dataItem.isActive">{{
                    $t("lbl_EMPBE_Disabled")
                  }}</span>
                </td>
              </template>
              <template v-slot:adExpiryDateTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                  {{ DisplayDate(props.dataItem.adExpiryDate, "-") }}<br />
                  <span class="badge badge-light" v-if="!props.dataItem.isActive">{{
                    $t("lbl_EMPBE_Disabled")
                  }}</span>
                </td>
              </template>
              <!-- <template v-slot:companyInfoTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                      {{
                        GetCompRate(props.dataItem)
                      }}
                    <div v-if="DisplayDate(props.dataItem.lastCompanySubmitDate)">
                      <span>{{ $t("lbl_EMPBE_LastSubmit") }}:
                        {{ DisplayDate(props.dataItem.lastCompanySubmitDate) }}</span>
                    </div>
                </td>
              </template> -->
              <!-- <template v-slot:productInfoTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">
                    {{
                       GetProdCount(props.dataItem)
                    }}
                    <div v-if="props.dataItem.lastThreeMonthExhibitCount">
                      <span>{{ $t("lbl_EMPBE_LastThreeMonthUpdateCount") }}:
                        {{ props.dataItem.lastThreeMonthExhibitCount }}</span>
                    </div>                    
                </td>
              </template> -->
              <!--广告状态-->
              <template v-slot:adInfoTemplate="{ props }">
                <td v-if="props.rowType !== 'groupHeader'">                    
                  
                    <AdsInfoStatusBadge :data="props.dataItem.adInfoFieldStatus"></AdsInfoStatusBadge>
                    <br/>
                    <div v-if="DisplayDate(props.dataItem.lastAdSubmitDate)">
                      <span>{{ $t("lbl_EMPBE_LastSubmit") }}:
                        {{ DisplayDate(props.dataItem.lastAdSubmitDate) }}</span>
                    </div>
                    <div v-if="DisplayDate(props.dataItem.lastAdApprovalDate)">
                      <span>{{ $t("lbl_EMPBE_LastApproveDate") }}:
                        {{ DisplayDate(props.dataItem.lastAdApprovalDate) }}</span>
                    </div>
                  
                </td>
              </template>
            </Grid>
          </intl>
        </localization>
      </div>
    </div>
    <!-- Container-fluid Ends-->
    <div class="b-sidebar-backdrop bg-dark" style="z-index: 100" v-if="sidebarMenu"
      @click="handleSidebarHide(selectedAccoountId)"></div>
    <b-sidebar :title="getCompanyNameWithLang(selectedDataItem)" :id="'supplier-sidebar'" :ref="'supplier'" bg-variant="white"
      right :shadow="true" v-model="sidebarMenu">
      <!-- <supplierDetail :supplierId="'1004320'"></supplierDetail> -->
      <supplierDetail 
        :supplierId="selectedAccoountId" 
        :simulatedSupplier="selectedDataItem" 
        :sidebarStrus="sidebarMenu"
        :openTabIndex="4"
        :id="'supplier'" 
        :ref="'supplier_detail'"
        fromPage="Ad"
      />
      <div class="d-flex" slot="header" style="align-items: center;">
        <button type="button" style="border: none; background-color: transparent;align-items: center;justify-content: center;display: flex;"
          @click="handleSidebarHide(selectedAccoountId)">
          <i class="icon-close f-14"></i>
        </button>
        <div style="font-size: 18px;color: rgba(0, 0, 0, 0.80);align-items: center;padding-left:8px;">{{ $t('lbl_EMPBE_AdApproval') }}</div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import { adminService } from "../../_services";
import supplierDetail from "./supplierDetail/default.vue";
import DisableItemVue from "./RightPopUp/DisableItem.vue";
import ResetPasswordVue from "./RightPopUp/ResetPassword.vue";
import { Grid, GridToolbar } from "@progress/kendo-vue-grid";
import { process } from "@progress/kendo-data-query";
import { computed } from "vue";
import {
  IntlProvider,
  load,
  LocalizationProvider,
  loadMessages,
} from "@progress/kendo-vue-intl";
import ColumnMenu from "./ColumnMenu";
import AdsInfoStatusBadge from "./Ads_InfoStatusBadge.vue";
import AccountTypeColumnMenu from "./ColumnMenu/AccountTypeColumnMenu";
import CompanyInfoFieldColumnMenu from "./ColumnMenu/CompanyInfoFieldColumnMenu.vue";
import ProductInfoFieldColumnMenu from "./ColumnMenu/ProductInfoFieldColumnMenu.vue";
import AdInfoFieldColumnMenu from "./ColumnMenu/Ads_AdInfoFieldColumnMenu.vue";
import eBoothTypeColumnMenu from "./ColumnMenu/Ads_eBoothTypeColumnMenu.vue";
import packageTypeColumnMenu from "./ColumnMenu/packageTypeColumnMenu.vue";
import { AlertDialog } from "@/_helpers/AlertDialog";

import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import currencyData from "cldr-core/supplemental/currencyData.json";
import weekData from "cldr-core/supplemental/weekData.json";

import numbers from "cldr-numbers-full/main/zh-Hans/numbers.json";
import caGregorian from "cldr-dates-full/main/zh-Hans/ca-gregorian.json";
import dateFields from "cldr-dates-full/main/zh-Hans/dateFields.json";
import timeZoneNames from "cldr-dates-full/main/zh-Hans/timeZoneNames.json";
load(
  likelySubtags,
  currencyData,
  weekData,
  numbers,
  caGregorian,
  dateFields,
  timeZoneNames
);

export default {
  mixins: [AlertDialog],
  components: {
    supplierDetail,
    DisableItemVue,
    ResetPasswordVue,
    Grid: Grid,
    toolbar: GridToolbar,
    localization: LocalizationProvider,
    intl: IntlProvider,
    customMenu: ColumnMenu,
    AccountTypeColumnMenu: AccountTypeColumnMenu,
    CompanyInfoFieldColumnMenu: CompanyInfoFieldColumnMenu,
    ProductInfoFieldColumnMenu: ProductInfoFieldColumnMenu,
    AdInfoFieldColumnMenu: AdInfoFieldColumnMenu,
    AdsInfoStatusBadge: AdsInfoStatusBadge,
    eBoothTypeColumnMenu: eBoothTypeColumnMenu,
    packageTypeColumnMenu: packageTypeColumnMenu
  },
  data() {
    return {
      type: "",
      dirty: false,
      sidebarMenu: false,
      items: [],
      loader: false,
      gridData: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      rowSelected: [],
      skip: 0,
      take: 5,
      group: [],
      sort: [],
      filter_Null:
        {
          "filters":[]
        },
      filter_ebooth:
        {
          "filters":[]
        }
        ,
         filter_adStatus:
        {
          "filters":[]
        }
        ,
      filter: this.$route.query.pending
        ? {
          filters: [
            {
              logic: "or",
              filters: [
                {
                  field: "adInfoFieldTc",
                  operator: "eq",
                  value: this.$t("lbl_EMPBE_Ad_Status_Pending"),
                },
              ],
            },
          ],
          logic: "and",
        }
        : this.$route.query.accountid
          ? {
            logic: "or",
            filters: [
              {
                field: "accountId",
                operator: "contains",
                value: this.$route.query.accountid,
              },
            ],
          }
          : null, //[20231005][JWS] Defailt loading pending if query have pending
      gridPageable: {
        buttonCount: 5,
        info: true,
        type: "numeric",
        pageSizes: true,
        previousNext: true,
      },
      searchWord: "",
      selectedField: "selected",
      columnMenu: true,
      memberGradeList: [],
      selectedDataItem: {},
      selectedAccoountId: '0',
      isFirstLoad: true,
      packageTypeList: [],
    };
  },
  computed: {
    companyName() {
      if (
        this.langid === "950" &&
        this.props.dataItem.companyNameTc !== this.props.dataItem.companyNameEn
      ) {
        return this.props.dataItem.companyNameTc;
      } else if (
        this.props.dataItem.companyNameSc !== this.props.dataItem.companyNameEn
      ) {
        return this.props.dataItem.companyNameSc;
      } else {
        return this.props.dataItem.companyNameEn;
      }
    },
    kendoLang() {
      var langid = localStorage.getItem("currentLangId");
      switch (langid) {
        case "1252":
          return "en-US";
        case "950":
          return "zh-Hant";
        case "936":
          return "zh-Hans";
        default:
          return "zh-Hans";
      }
    },
    selectedDataItems() {
      console.log('selectedDataItems');
      return this.gridData.data.filter((item) => item.selected === true);
    },
    areAllSelected() {
      return (
        this.selectedDataItems.length === this.gridData.data.length &&
        this.selectedDataItems.length !== 0
      );
    },
    columns() {
      var res = [];
      return [
        {
          field: "selected",
          title: " ",
          width: "45px",
          columnMenu: false,
          headerSelectionValue: this.areAllSelected,
        },
        {
          field: "CompanyNameEn",
          title: this.$t("Lbl_CompanyName"),
          cell: "companyNameTemplate",
          width: "180px",
          filter: false,
          columnMenu: false,
        },
        /*{
          field: "displayName",
          title: this.$t("lbl_EMPBE_UserName"),
          cell: "displayNameTemplate",
          filter: false,
          columnMenu: false,
          width: "150px",
        },*/
        {
          field:"eBoothGrade",
          title: this.$t("lbl_EMPBE_eBoothType"),
          filter: false,
          columnMenu: false,
          //columnMenu: "eBoothTypeColumnMenuTemplate",
           cell: "eBoothTypeTemplate",
          width: "150px",
        },
        {
          field:"packageNameSc",
          title: this.$t("lbl_EMPBE_SponsorshipAdPackage"),
          filter: false,
          columnMenu: false,
          cell: "packageTypeTemplate",
          //columnMenu: "packageTypeColumnMenuTemplate",
          width: "200px",
        },
        {
          field: "membershipExpiryDate",
          title: this.$t("lbl_EMPBE_MemberEffectiveDate"),
          cell: "membershipExpiryDateTemplate",
          filter: false,
          columnMenu: false,
          format: "{0:D}",
          width: "180px",
        },
        {
          field: "adExpiryDate",
          title: this.$t("lbl_EMPBE_AdEffectiveDate"),
          cell: "adExpiryDateTemplate",
          filter: false,
          columnMenu: false,
          format: "{0:D}",
          width: "180px",
        },
        {
          field:"adInfoFieldStatus",
          title: this.$t("lbl_EMPBE_AdInfoStatus"),
          cell: "adInfoTemplate",
          filter: false,
          //columnMenu: false,
          columnMenu: "AdInfoMenuTemplate",
          width: "200px",
        },
        {
          field:"empCompanyId",
          title: this.$t("lbl_EMPBE_AdminOrder_EMP_CompanyId"),
          cell: "EMP_CompanyIdTemplate",
          width: "150px",
          filter: false,
          columnMenu: false,
        },
        {
          field:"prospectId",
          title: this.$t("lbl_EMPBE_AdminOrder_Prospect_ID"),
          cell: "Prospect_IDTemplate",
          width: "150px",
          filter: false,
          columnMenu: false,
        },
        {
          field:"pubIoNo",
          title: this.$t("lbl_EMPBE_AdminOrder_PUB_IO"),
          cell: "PUB_IOCodeTemplate",
          width: "150px",
          filter: false,
          columnMenu: false,
        },
        {
          field:"contractNo",
          title: this.$t("lbl_EMPBE_AdminOrder_Contract_No"),
          cell: "Contract_NoTemplate",
          width: "150px",
          filter: false,
          columnMenu: false,
        },      
        {
          field:"salesCodePub",
          title: this.$t("lbl_EMPBE_AdminOrder_PUB_SalesCode"),
          cell: "PUB_SalesCodeTemplate",
          width: "150px",
          filter: false,
          columnMenu: false,
        },     
        {
          field:"salesCodeCrm",
          title: this.$t("lbl_EMPBE_AdminOrder_CRM_SalesCode"),
          cell: "CRM_SalesCodeTemplate",
          width: "150px",
          filter: false,
          columnMenu: false,
        },   
      ];
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
  },
  created() {
    this.gridData = this.getData(this.items);
  },
  mounted() {
    // Set the initial number of items
    this.LoadBasicData();
    this.totalRows = this.items.length;
    this.LoadSupplierData();
  },
  methods: {
    GetCompRate(item){
      return this.$t("lbl_EMPBE_CompanyCompletePercentage").replace('{{percentageOfProfileCompletion}}',item.companyRate);
    },    
    GetProdCount(item){
      return this.$t("lbl_EMPBE_PostedProductCount").replace('{{noOfPostedProducts}}',item.prodUsedQty).replace('{{noOfEntitledProducts}}', item.prodQty);
    },    
    handleSidebarHide(id) {
      this.selectedAccoountId=0; 
      if (this.$store.state.dirty) {
        this.showLeavePage().then((result) => {
          if (result.isConfirmed) {
            this.$refs["supplier"].hide();
            this.$store.state.dirty = false;
          }
        });
      } else {
        // this.$refs.supplierDetail.refresh();
        this.$refs["supplier"].hide();
      }
      
    },
    openSidebar(dataItem) {
      if(dataItem){
      this.selectedDataItem = dataItem;
      this.selectedAccoountId = dataItem.accountId+'';
      this.sidebarMenu = true; 
      }
    
      //this.$refs['supplier_detail'].refresh();
    },
    LoadSupplierData() {
      console.log('LoadSupplierData')
      this.loader = true;
      var that = this;
      var sortColumns = ""; 
      that.sort.forEach((element) => {
        sortColumns += element.field+' ' +element.dir+ ",";
       // sortDirections += element.dir + ",";
      }); 
      if (sortColumns.length > 0) {
        sortColumns = sortColumns.substring(0, sortColumns.length - 1);
       // sortDirections = sortDirections.substring(0, sortDirections.length - 1);
      }
      let searchText = this.searchWord.trim();
      let fitercolunms=JSON.stringify(that.filter);
       console.log('fitercolunm:'+fitercolunms);
      that.currentPage = (that.skip + that.take) / that.take;
      adminService
        .GetSupplierList_Ads(
          searchText,
          fitercolunms,
          sortColumns, 
          that.currentPage,
          that.take
        )
        .then((res) => {
          that.items = res.supplierListingInfos;
         if(that.items&&that.items.length>0){
          that.items.forEach(element => {
            element.eBoothGradeName = that.geteBoothGradeName(element.eBoothGrade)
          });
        }
          that.totalRows = res.count;
          that.gridData = that.getData(that.items);
        })
        .catch(() => {
          that.items = [];
          that.totalRows = 0;
          that.gridData = that.getData(that.items);
        })
        .finally(() => {
          that.loader = false;
          if (that.isFirstLoad) {
            if (that.$route.query.accountid) {
              var currentItem = that.gridData.data.filter(
                (x) => x.accountId == that.$route.query.accountid
              );
              if (currentItem.length > 0) {
                that.searchWord = that.$route.query.accountid;
                that.openSidebar(currentItem[0]);
                that.$root.$emit("bv::toggle::collapse", "supplier");
              }
            }

            that.isFirstLoad = false;
          }
        });
    },
    LoadBasicData(){
      var that = this;
      adminService
        .GetSupplierList_AdsBasicData()
        .then((res) => {
           
           that.memberGradeList = res.memberGradeInfos;
            that.packageTypeList = res.packageNameInfos; 
        })
    },
    pageChangeHandler(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
      this.currentPage = (event.page.skip + event.page.take) / event.page.take;
      this.LoadSupplierData();
    },
    onSelectionChange(event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField];
      this.gridData = this.getData(this.items); //[wxy]重置密码：更新griddate,调用selectedDataItems，使选中的条数正确
    },
    handleFilterChange: function (filter) {
      this.filter = filter;
      // this.gridData = this.getData(this.items);
      this.LoadSupplierData();
    }, 
      setEboothFilter(fiterJson) {
        console.log('fiterJson'+fiterJson);
      this.filter_ebooth=fiterJson;
    },
    setAdInfoFilter(fiterJson){
      console.log('setAdInfoFilter -fiterJson:'+fiterJson);
      console.log(fiterJson); 
      this.filter_adStatus = fiterJson; 
    },
    onFilter(e) {
      let inputValue = this.searchWord.trim();
      this.skip = 0;
      this.filter_ebooth=this.filter_Null;
        this.filter_adStatus=this.filter_Null;
      if (inputValue !== "") {
        
        this.filter = this.filter_Null ;
      } else this.filter = null;
      // this.gridData = this.getData(this.items);
      this.LoadSupplierData();
    },
    onHeaderSelectionChange(event) {
      let checked = event.event.target.checked;
      const tempData = this.items.map((item) => {
        return { ...item, selected: checked };
      });

      const tempGridData = this.gridData.data.map((item) => {
        return { ...item, selected: checked };
      });
      this.gridData.data = tempGridData;
      this.items = tempData;
    },
    getData(data) {
      // return data;
      return process(data, {
        // take: this.take,
        // skip: this.skip,
        // group: this.group,
        // sort: this.sort,
        // filter: this.filter,
      });
    },
    createAppState: function (dataState) {
      this.group = dataState.group;
      this.take = dataState.take;
      this.skip = dataState.skip;
      this.sort = dataState.sort;
      this.filter = dataState.filter;

      // this.gridData = this.getData(this.items);
      this.LoadSupplierData();
    },
    dataStateChange: function (event) {
      this.createAppState(event.data);
    },
    getCompanyNameWithLang(item) {
      return this.langid == "1252"
        ? item.companyNameEn
        : this.langid == "950"
          ? item.companyNameTc
          : item.companyNameSc;
    },
    getMemberGradeWithLang(item) {
      return this.langid == "1252"
        ? item.memberGradeEn
        : this.langid == "950"
          ? item.memberGradeTc
          : item.memberGradeSc;
    },
    geteBoothGradeName(eBoothGrade) {
      switch (eBoothGrade) {
         case "A+":
          return this.$t('lbl_EMPBE_GradeA');
        case "A":
          return this.$t('lbl_EMPBE_GradeA');
        case "B":
          return this.$t('lbl_EMPBE_GradeB');
        case "C":
          return this.$t('lbl_EMPBE_GradeC');
         case "Basic":
          return this.$t('lbl_emp2_BasicEbooth');
           case "Free":
          return this.$t('lbl_EMPBE_FreeEBooth');
            case "no_ebooth":
          return this.$t('lbl_EMPBE_NoEBooth');
          default:
            return '-';
        // default:
        //   if (item.MemberCode == 'BASIC') {
        //     return this.$t('lbl_emp2_BasicEbooth');
        //   } else if (item.isExhibitor) {
        //     return this.$t('lbl_EMPBE_FreeEBooth');
        //   } else {
        //     return "-"
        //   }
      }
    },
    getPackageNameArray(item) {
      var nameString = item.packageNameSc;
      if(nameString == "" || nameString == undefined) return [];
      return nameString.split(',');
    },
    getCompanyInfoFieldWithLang(item) {
      return this.langid == "1252"
        ? item.companyInfoFieldEn
        : this.langid == "950"
          ? item.companyInfoFieldTc
          : item.companyInfoFieldSc;
    },
    getProductInfoFieldWithLang(item) {
      return this.langid == "1252"
        ? item.productInfoFieldEn
        : this.langid == "950"
          ? item.productInfoFieldTc
          : item.productInfoFieldSc;
    },
    getAdInfoFieldWithLang(item) {
      return this.langid == "1252"
        ? item.adInfoFieldEn
        : this.langid == "950"
          ? item.adInfoFieldTc
          : item.adInfoFieldSc;
    },
    DisplayDate(dateString, defaultValue = "") {
      if (dateString == "0001-01-01 00:00:00") return defaultValue;
      try {
        var date = new Date(dateString);
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [
          date.getFullYear() + "/",
          (mm > 9 ? "" : "0") + mm + "/",
          (dd > 9 ? "" : "0") + dd,
        ].join("");
      } catch (ex) {
        return defaultValue;
      }
    },
    onColumnsSubmit(columnsState) {
      this.columns = columnsState;
    },
    showAlert(message) {
      this.$swal({
        html: message,
        htmlMode: true,
        //icon: variant, // 可以是 success、error、warning、info、question 等图标
        showConfirmButton: true, // 禁用确认按钮
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        //allowOutsideClick: false, // 防止点击外部关闭
        //allowEscapeKey: false, // 防止按下 ESC 键关闭
      });
    },
    resetPassword(accountId) {
      var selectedItems =
        accountId <= 0
          ? this.selectedDataItems
          : this.gridData.data.filter((x) => x.accountId == accountId);
      if (accountId <= 0 && selectedItems.length < 1) {
        this.showAlert(this.$t("Lbl_Popupform_Error"));
        // } else if (accountId <= 0 && selectedItems.length > 10) {
        //   this.showAlert(this.$t("lbl_MaximumTenOptions"));
      } else {
        this.$swal({
          text: this.$t("lbl_EMPBE_AreYouSureToSubmit"),
          showCancelButton: true,
          type: "confirm",
          showConfirmButton: true,
          confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
          cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
        }).then((result) => {
          if (result.value) {
            var paramList = selectedItems.map((item) => ({
              accountId: item.accountId,
              langId: this.langid,
              isUat: false,
            }));
            adminService.SendForgetPasswordByAdmin(paramList).then((res) => {
              var msg = "";
              if (
                res.statusCode != 500 &&
                res.systemErrorMsg &&
                res.systemErrorMsg.length > 0
              ) {
                res.systemErrorMsg.forEach((element, index) => {
                  var tempArray = element.split(":");
                  const selectedAccount = selectedItems.find(
                    (item) => item.accountId == tempArray[0]
                  );
                  let displayName = "";
                  if (selectedAccount) {
                    displayName =
                      this.langid === 950
                        ? selectedAccount.companyNameTc
                        : this.langid === 1252
                          ? selectedAccount.companyNameEn
                          : selectedAccount.companyNameSc;
                  }
                  var tempStr =
                    displayName +
                    ": Email / " +
                    this.$t("lbl_Mobile") +
                    " " +
                    this.$t("lbl_EMPBE_grid_filterIsEmptyOperator") +
                    "<br>";
                  msg += tempStr;
                });
              } else {
                msg = res.systemErrorMsg.join("<br>");
              }
              if (res.data && res.data.length > 0) {
                res.data.forEach((element, index) => {
                  var selectedAccount = selectedItems.find(
                    (item) => item.accountId == element.data
                  );
                  let displayName = "";
                  if (selectedAccount) {
                    displayName =
                      this.langid === 950
                        ? selectedAccount.companyNameTc
                        : this.langid === 1252
                          ? selectedAccount.companyNameEn
                          : selectedAccount.companyNameSc;
                  }
                  if (element.isSuccessful) {
                    const temp = this.$t("lbl_EMPBE_ResetPasswordSendResult1");
                    msg += `${displayName}: ${temp}`;
                  } else {
                    const temp = this.$t("lbl_EMPBE_ResetPasswordSendResult2");
                    msg += `${displayName}: ${temp}`;
                  }
                });
              }
              this.showAlert(msg);
            });
          }
        });
      }
    },
    researchSubmit(accountId) {
      var selectedItems = accountId <= 0
        ? this.selectedDataItems
        : this.gridData.data.filter((x) => x.accountId == accountId);

      if (accountId <= 0 && selectedItems.length < 1) {
        this.showAlert(this.$t("Lbl_Popupform_Error"));
        return;
      }

      const that = this;
      const companyNames = selectedItems.map((x) => x.companyField).join(", ");

      this.$swal({
        text: "Are you sure to submit company AI research preview with: " + companyNames,
        showCancelButton: true,
        type: "confirm",
        showConfirmButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      }).then((result) => {
        if (!result.value) return;

        const companyIds = selectedItems.map((x) => x.accountId).join(",");
        const params = {
          companyIds,
        };

        adminService.SubmitAiResearchPreview(params).then((res) => {
          if (!res.isSuccessful) {
            console.error(res?.systemErrorMsg[0] ?? "");
          }

          const msg = res.isSuccessful ? that.$t("lbl_EMPBE_SubmitSuccess") : that.$t("lbl_emp2_PopupFailedTitle");
          that.showAlert(msg);
        });
      });
    },
    researchCompany(accountId, triggerCode) {
      var selectedItems = accountId <= 0
        ? this.selectedDataItems
        : this.gridData.data.filter((x) => x.accountId == accountId);

      if (accountId <= 0 && selectedItems.length < 1) {
        this.showAlert(this.$t("Lbl_Popupform_Error"));
        return;
      }

      const that = this;
      const companyNames = selectedItems.map((x) => x.companyField).join(", ");

      this.$swal({
        text: "Are you sure to do company research with: " + companyNames,
        showCancelButton: true,
        type: "confirm",
        showConfirmButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      }).then((result) => {
        if (!result.value) return;

        const companyIds = selectedItems.map((x) => x.accountId).join(",");
        const params = {
          companyIds,
          triggerCode,
        };

        adminService.InsertAiCompanyResearchQueue(params).then((res) => {
          if (!res.isSuccessful) {
            console.error(res?.systemErrorMsg[0] ?? "");
          }

          const msg = res.isSuccessful ? that.$t("lbl_EMPBE_SubmitSuccess") : that.$t("lbl_emp2_PopupFailedTitle");
          that.showAlert(msg);
        });
      });
    },
    submitReminder(accountId) {
      var selectedItems =
        accountId <= 0
          ? this.selectedDataItems
          : this.gridData.data.filter((x) => x.accountId == accountId);
      if (accountId <= 0 && selectedItems.length < 1) {
        this.showAlert(this.$t("Lbl_Popupform_Error"));
        // } else if (accountId <= 0 && selectedItems.length > 10) {
        //   this.showAlert(this.$t("lbl_MaximumTenOptions"));
      } else {

        this.$swal({
          text: this.$t("lbl_EMPBE_AreYouSureToSubmit"),
          showCancelButton: true,
          type: "confirm",
          showConfirmButton: true,
          confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
          cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
        }).then((result) => {
          if (result.value) {
            var list = selectedItems.map((item) => ({
              accountId: item.accountId,
              langId: this.langid,
              // isUat: true,
            }));

            //Get Current User Login for Logging
            var currentUser = this.$store.state.authentication.user; 
            //var currentUser = JSON.parse(localStorage.getItem("user"));
            
            var currentLogin = "SYSTEM";
            if (currentUser != null){
              currentLogin = currentUser.login;
            }

            var paramList = {
              DetailList: list,
              action: {
                'LangId': localStorage.getItem('currentLangId')
                , 'IP': window.location.host
                , 'URL': window.location.href
                , 'Referral': document.referrer
                , 'BAgent': window.navigator.userAgent
                , 'Action': "SendReminderEmailAll"
                , 'ActionBy': currentLogin
              }
            }

            adminService.SubmitReminderEmail(paramList).then((res) => {
              var msg = "";
              if (!res.isSuccessful) {
                msg = res.systemErrorMsg.join("<br>");
              } else {
                msg = this.$t('lbl_EMPBE_SubmitReminderEmailSuccess')
              }
              this.showAlert(msg);
            });
          }
        })
      }
    },
    submitReminderAll() {
       this.$swal({
          text: this.$t("lbl_EMPBE_AreYouSureToSubmit"),
          showCancelButton: true,
          type: "confirm",
          showConfirmButton: true,
          confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
          cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
        }).then((result) => {
          if (result.value) {

            //Get Current User Login for Logging
            var currentUser = this.$store.state.authentication.user; 
            //var currentUser = JSON.parse(localStorage.getItem("user"));
            var currentLogin = "SYSTEM";
            if (currentUser != null){
              currentLogin = currentUser.login;
            }

            var paramList = {
              //ForDebug
              //IsTest: true,
              //TestEmail:"wardho@adsale.com.hk",

              IsTest: false,
              TestEmail:"",
              Source: "EMPBE_Admin",
              action: {
                'LangId': localStorage.getItem('currentLangId')
                , 'IP': window.location.host
                , 'URL': window.location.href
                , 'Referral': document.referrer
                , 'BAgent': window.navigator.userAgent
                , 'Action': "SendReminderEmailAll"
                , 'ActionBy': currentLogin
              }
            }

            adminService.SubmitReminderEmailAll(paramList).then((res) => {
              var msg = "";
              if (!res.isSuccessful) {
                msg = res.systemErrorMsg.join("<br>");
              } else {
                msg = this.$t('lbl_EMPBE_SubmitReminderEmailSuccess')
              }
              this.showAlert(msg);
            });
          }
        })
    },
    sendAccountPassword(accountId) {
      var selectedItems =
        accountId <= 0
          ? this.selectedDataItems
          : this.gridData.data.filter((x) => x.accountId == accountId);
      if (accountId <= 0 && selectedItems.length < 1) {
        this.showAlert(this.$t("Lbl_Popupform_Error"));
        // } else if (accountId <= 0 && selectedItems.length > 10) {
        //   this.showAlert(this.$t("lbl_MaximumTenOptions"));
      } else {
        
        this.$swal({
          text: this.$t("lbl_EMPBE_AreYouSureToSubmit"),
          showCancelButton: true,
          type: "confirm",
          showConfirmButton: true,
          confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
          cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
        }).then((result) => {
          
          if (result.value) {
            var list = selectedItems.map((item) => ({
              accountId: item.accountId,
              langId: this.langid,
              // isUat: true,
            }));
            //Get Current User Login for Logging
            var currentUser = this.$store.state.authentication.user; 
            //var currentUser = JSON.parse(localStorage.getItem("user"));
            var currentLogin = "SYSTEM";
            if (currentUser != null){
              currentLogin = currentUser.login;
            }
            var paramList = {
              DetailList: list,
              action: {
                'LangId': localStorage.getItem('currentLangId')
                , 'IP': window.location.host
                , 'URL': window.location.href
                , 'Referral': document.referrer
                , 'BAgent': window.navigator.userAgent
                , 'Action': "SendAccountPassword"
                , 'ActionBy': currentLogin
              }
            }

            adminService.SendAccountPasswordEmail(paramList).then((res) => {
              var msg = "";
              if (!res.isSuccessful) {
                msg = res.systemErrorMsg.join("<br>");
              } else {
                msg = this.$t('lbl_EMPBE_SendAccountPasswordEmailSuccess')
              }
              this.showAlert(msg);
            });
          }
        })
      }
    },
  
  },
  provide() {
    return {
      sidebarIsOpen: computed(() => this.sidebarMenu)
    }
  },
};
</script>
<style>

.datatable-vue table tbody tr td {
  vertical-align: initial !important;
}

.table.b-table.b-table-selectable:not(.b-table-selectable-no-click)>tbody>tr {
  cursor: auto !important;
}

.actionBtn button {
  padding: 0.375rem 1.75rem !important;
}

.b-sidebar-backdrop {
  opacity: 0.09 !important;
}

/* 广告审批侧栏：横幅配置+预览并排需更宽，对齐公司审批 95%（全局 .b-sidebar 默认仅 60%） */
#supplier-sidebar.b-sidebar {
  min-width: 800px !important;
  width: 95% !important;
}

.actionBtn > .dropdown-menu{
  overflow: auto;
  max-height: 300px;
}

.container-fluid .k-grid-container {
   min-height: 400px !important;
}

/* 确保 CatalogueModal 弹框显示在 supplier sidebar (z-index: 1041) 之上 */
/* 当 supplier sidebar 打开时，确保 CatalogueModal 显示在其上方 */
#CategoryModal {
  z-index: 1055 !important;
}

/* 确保 CatalogueModal 的背景遮罩也在 sidebar 之上 */
/* 只有当 CategoryModal 显示时才应用此样式 */
body.modal-open:has(#CategoryModal.show) .modal-backdrop,
#CategoryModal.show ~ .modal-backdrop {
  z-index: 1054 !important;
}
#supplier >.b-sidebar > .b-sidebar-header{
  align-items: center !important;
  justify-content:center !important;
}
 /* #supplier .card-header:nth-child(1){ 
  margin-left:35px ;
  background-color: rgba(0, 0, 0, 0.03);
    padding-top: 12px; 
  padding: .75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, .03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  border-top-left-radius: 15px ;
  border-top-right-radius: 15px;
  position: relative;
} */
#supplier > .b-sidebar-header:nth-child(1) {
      padding: 0.25rem;
      /* position: fixed;  */
      z-index: 10001;
}
/* #supplier >  .card-header:nth-child(1) {
    width: 93%;
    margin-left: 50px;
}    */
#supplier >.b-sidebar.b-sidebar-right > .b-sidebar-header .close{
  margin-right: 8px;
  position: absolute;
    left: 10px;
} 
#AdCPSOLExhibitorList >.b-sidebar.b-sidebar-right > .b-sidebar-header .close{
  margin-right: 8px;
  position: absolute;
    left: 10px;
} 
#SupplierList_grid td{
  word-break: break-all;
}
/* [20230908][wxy] _grid.css统一处理
.k-grid td {
  overflow: visible !important;
}

.k-grid-toolbar {
  overflow: visible !important;
}

.k-grid-container {
   min-height: 130px; 
} */
</style>
